var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 22,
    viewBox: "0 0 156 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_2623)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 9.4894L9.22143 18.9698L9.21249 18.9788H0L2.67301 16.2266L9.21249 9.49388L2.68642 2.73879L0.0446991 0H9.21249L9.21696 0.00896495L18.7826 9.4894Z",
    fill: "#5D44FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8207 12.8154C34.8207 15.6393 32.7422 17.2978 29.3451 17.2978H21.3037V1.61365H28.9428C32.1388 1.61365 34.262 3.3394 34.262 5.872C34.262 7.32881 33.5468 8.42701 32.3846 9.09939C33.8597 9.81658 34.8207 11.0941 34.8207 12.8198M24.9243 4.79621V7.93394H28.9473C29.9306 7.93394 30.6458 7.21674 30.6458 6.32025C30.6458 5.42375 29.9306 4.77379 28.9473 4.79621H24.9243ZM29.3496 14.0929C30.4894 14.0929 31.1375 13.3757 31.1375 12.4568C31.1375 11.493 30.4894 10.8431 29.3496 10.8431H24.9243V14.0929H29.3496Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8206 11.6052C34.8206 8.17608 37.212 5.55383 40.8549 5.55383C44.4979 5.55383 46.8223 8.17608 46.8223 11.4707C46.8223 11.8741 46.7999 12.2775 46.7329 12.6586H38.3116C38.5351 13.7344 39.3173 14.6309 41.15 14.6309C42.3568 14.6309 43.0497 14.1602 43.4296 13.4654L46.6479 14.4067C46.0445 15.8187 44.1224 17.6117 41.0829 17.6117C37.3729 17.6117 34.825 15.1687 34.825 11.6097M43.3357 10.507C43.224 9.476 42.3077 8.55709 40.8326 8.55709C39.3575 8.55709 38.4635 9.54324 38.3071 10.507H43.3357Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.266 5.87207H59.0833L52.3158 22H48.6729L50.7067 17.029L50.8631 17.0065L50.7067 17.029L45.5886 5.87207H49.4998L52.4723 12.8378L55.266 5.87207Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.033 11.5827C58.033 8.15358 60.6032 5.55823 64.1567 5.55823C67.7103 5.55823 70.2805 8.15806 70.2805 11.5827C70.2805 15.0073 67.7103 17.6071 64.1567 17.6071C60.6032 17.6071 58.033 15.0073 58.033 11.5827ZM66.8163 11.5827C66.8163 9.96898 65.7883 8.78113 64.1567 8.78113C62.5252 8.78113 61.4971 9.96898 61.4971 11.5827C61.4971 13.1964 62.5252 14.3842 64.1567 14.3842C65.7883 14.3842 66.8163 13.1964 66.8163 11.5827Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3402 10.6414V17.2934H78.7642V11.3541C78.7642 9.85244 78.1385 8.8663 76.7304 8.8663C75.3224 8.8663 74.5178 9.9645 74.5178 11.7127V17.2889H70.9419V5.872H74.5178V7.05986C75.2777 6.18577 76.4175 5.55823 77.8926 5.55823C80.9321 5.55823 82.3402 7.62017 82.3402 10.6458",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7941 0.941284H95.2985V17.2978H91.7897V16.1772C91.0074 17.0513 89.8676 17.6116 88.4372 17.6116C85.353 17.6116 82.8945 15.0566 82.8945 11.5872C82.8945 8.11773 85.353 5.55823 88.4372 5.55823C89.8899 5.55823 91.0074 6.09613 91.7897 6.99263V0.941284H91.7941ZM91.8165 11.5603C91.8165 9.85693 90.6319 8.73631 89.0898 8.73631C87.5477 8.73631 86.4302 9.85693 86.4302 11.5603C86.4302 13.2636 87.5477 14.4291 89.0898 14.4291C90.6319 14.4291 91.8165 13.286 91.8165 11.5603Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.35 13.8912H107.698V17.2978H96.6396V0.941284H100.35V13.8912Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.318 11.6052C107.318 8.17608 109.71 5.55383 113.352 5.55383C116.995 5.55383 119.32 8.17608 119.32 11.4707C119.32 11.8741 119.297 12.2775 119.23 12.6586H110.809C111.033 13.7344 111.815 14.6309 113.648 14.6309C114.854 14.6309 115.547 14.1602 115.927 13.4654L119.146 14.4067C118.542 15.8187 116.62 17.6117 113.58 17.6117C109.87 17.6117 107.323 15.1687 107.323 11.6097M115.833 10.507C115.722 9.476 114.805 8.55709 113.33 8.55709C111.855 8.55709 110.961 9.54324 110.805 10.507H115.833Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.211 5.872H131.719V17.2978H128.211V16.1772C127.428 17.0513 126.288 17.6116 124.858 17.6116C121.774 17.6116 119.315 15.0566 119.315 11.5872C119.315 8.11772 121.774 5.55835 124.858 5.55835C126.311 5.55835 127.428 6.09613 128.211 6.99262V5.872ZM128.233 11.5603C128.233 9.85692 127.048 8.7363 125.506 8.7363C123.964 8.7363 122.847 9.85692 122.847 11.5603C122.847 13.2636 123.964 14.4291 125.506 14.4291C127.048 14.4291 128.233 13.286 128.233 11.5603Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28 0.941284H144.785V17.2978H141.276V16.1772C140.494 17.0513 139.354 17.6116 137.924 17.6116C134.839 17.6116 132.381 15.0566 132.381 11.5872C132.381 8.11773 134.839 5.55835 137.924 5.55835C139.376 5.55835 140.494 6.09613 141.276 6.99263V0.941284H141.28ZM141.298 11.5603C141.298 9.85693 140.114 8.73631 138.572 8.73631C137.03 8.73631 135.912 9.85693 135.912 11.5603C135.912 13.2636 137.03 14.4291 138.572 14.4291C140.114 14.4291 141.298 13.286 141.298 11.5603Z",
    fill: "black",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.35 14.3619H156V17.2979H145.634V15.0567L151.065 8.80361H145.768V5.87207H155.799V8.11331L150.35 14.3619Z",
    fill: "black",
    fillRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_2623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.e4a9f4c1391a5fd843193ddcfb68d195.svg";
export { ForwardRef as ReactComponent };